import React, { forwardRef } from 'react';
import * as RadixPopoverPrimitive from '@radix-ui/react-popover';
import { Button, GDSButtonSize } from '#components/button/button.tsx';
import { GDSIconSource } from '#components/icon/icon.tsx';
import type { GDSCustomizableComponent } from '../../types';
import { styled } from '../../theme';
import { GDSResponsiveProp } from '../../types';
import { GenesisCoreInspector } from '../../test-utils/genesis-core-inspector';

export interface GDSPopoverTriggerProps
  extends RadixPopoverPrimitive.PopoverTriggerProps,
    GDSCustomizableComponent {
  hideLabel?: boolean;
  icon?: GDSIconSource;
  label?: string;
  priority?: 'primary' | 'secondary' | 'tertiary';
  quiet?: boolean;
  size?: GDSResponsiveProp<GDSButtonSize>;
}

const DISPLAY_NAME = 'PopoverTrigger';

const BaseTrigger = styled(RadixPopoverPrimitive.Trigger, {});

export const PopoverTrigger = forwardRef<
  HTMLButtonElement,
  GDSPopoverTriggerProps
>(
  (
    {
      children,
      className,
      css,
      hideLabel,
      icon,
      label,
      priority,
      quiet,
      size,
      'data-testid': testId = `GDS-${DISPLAY_NAME}`,
      ...props
    },
    ref,
  ) => {
    if (!label && !children)
      console.warn(
        'To show a Popover initiator, set the label on Popover.Trigger or provide a custom button element as a child of Popover.Trigger.',
      );
    return (
      <GenesisCoreInspector displayName={DISPLAY_NAME}>
        <BaseTrigger
          className={['GDS-popover-trigger', className].join(' ')}
          css={css}
          ref={ref}
          data-testid={testId}
          asChild
        >
          {label ? (
            <Button
              hideLabel={hideLabel}
              icon={icon}
              priority={priority}
              quiet={quiet}
              size={size}
              {...props}
            >
              {label}
            </Button>
          ) : (
            children
          )}
        </BaseTrigger>
      </GenesisCoreInspector>
    );
  },
);
